import axios from 'axios';
import router from '@/router';
import store from '@/store';
import { Toast } from 'mand-mobile';
import { i18n } from '@/lang';
import Fingerprint2 from 'fingerprintjs2';
import { getBrowserLang, isAndroid, isIos, getQueryString } from '@utils';

let initialRedirectPath = null;

const locale = i18n.locale;
const messages = i18n.messages;
const lang = messages[locale];

let deviceNo = localStorage.getItem('deviceNo') || '';
if (!deviceNo) {
  const createFingerprint = () => {
    // 浏览器指纹
    // eslint-disable-next-line no-unused-vars
    const fingerprint = Fingerprint2.get((components) => { // 参数只有回调函数时，默认浏览器指纹依据全部配置信息进行生成
      const values = components.map(component => component.value); // 配置的值的数组
      deviceNo = Fingerprint2.x64hash128(values.join(''), 31); // 生成浏览器指纹
      localStorage.setItem('deviceNo', deviceNo); // 存储浏览器指纹，在项目中用于校验用户身份和埋点
    });
  };

  if (window.requestIdleCallback) {
    requestIdleCallback(() => {
      createFingerprint();
    });
  } else {
    setTimeout(() => {
      createFingerprint();
    }, 500);
  }
}

// 创建axios实例
const service = axios.create({
  timeout: 18000000, // 请求超时时间--30分钟
  baseURL: BASE_API_URL
});

/**
 * 添加request拦截器
 */

service.interceptors.request.use(config => {
  const Authorization = localStorage.getItem('token') || '';

  const Language = localStorage.getItem('lang') || getBrowserLang();

  // from 1 PC,  2 H5,  3:安卓APP,  4: IOS APP
  const isAndroidApp = store.state.publicStore.isApp && isAndroid();
  const isIosWebClip = (getQueryString('isWebClip') === '1' || localStorage.getItem('isWebClip') === '1') && isIos();

  let from = 2; // 默认 h5, 2
  if (isAndroidApp) {
    from = 3;
  }

  if (isIosWebClip) {
    from = 4;
  }

  config.headers = Object.assign(config.headers,
    // {'Content-Type': 'application/json;charset=UTF-8;application/x-www-form-urlencoded'},
    { 'access-token': Authorization, from, nation: Language, 'device-number': deviceNo || new Date().getTime() });
  return config;
}, error => {
  Promise.reject(error);
});

// 特殊状态处理
const handleResponse = (result, data, message) => {
  switch (result) {
    case 100001: {
      store.commit('user/setUserInfo', {});
      store.commit('user/setToken', '');
      store.commit('user/setWalletInfo', {});
      Toast.failed(lang.tokenTips);
      // 如果没有保存过初始路径，就设置初始路径
      const route = router.app._route;

      console.log('currentPath', route);
      if (!initialRedirectPath && !['/login'].includes(route.path)) {
        initialRedirectPath = route.fullPath;
      }

      if (!['/login'].includes(route.path)) {
        console.log('initialRedirectPath', initialRedirectPath);

        router.push(`/login?redirect=${initialRedirectPath}`);
        initialRedirectPath = null;
      }

      // router.push(`/login?redirect=${initialRedirectPath}`).then(res => {
      //   initialRedirectPath = null;
      // }).catch(err => {
      //   initialRedirectPath = null;
      //   console.log('失败了', err);
      // });
    }
      break;
    case 300000:// 系统维护
      store.commit('publicStore/setSysMaintenanceInfo', data.info);
      break;
  }
};

/**
 * 响应拦截器
 */
service.interceptors.response.use(
  // 请求成功
  res => {
    if (res.status === 200) {
      handleResponse(res.data.result, res.data.data, res.data.msg);
      // if (res.data.state == '6100') {
      //   Toast.failed(lang.goToDeposit);
      //   router.push('/depositWithdraw');
      // }
      return Promise.resolve(res.data);
    } else {
      return Promise.reject(res.data);
    }
  },
  // 请求失败
  error => {
    const { response } = error;
    if (response) {
      return Promise.reject(response);
    } else {
      // 处理断网的情况
    }
  });
export default service;
